import { render, staticRenderFns } from "./DocumentPagination.vue?vue&type=template&id=53a127a9&"
import script from "./DocumentPagination.vue?vue&type=script&lang=js&"
export * from "./DocumentPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports